import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'
import 'select2';
import { template } from 'lodash'
import { flashAlert } from '../shared/flash'

export default class extends Controller {
  static targets = [
    'amount',
    'percent',
    'amountWrapper',
    'percentWrapper',
    'discountType',
    'minDiscountWrapper',
    'maxDiscountWrapper',
    'revenueCategoriesType',
    'revenueCategoriesWrapper',
    'menu',
    'selectCategories',
    'revenueCategory',
    'revenueCategoryList',
    'revenueCategoryOptionTemplate',
  ];

  connect() {
    this.revenueCategoryOptionTemplate = template(this.revenueCategoryOptionTemplateTarget.innerHTML)
    this.API_BASE_URL = '/sandbar/admin'

    if (this.discountTypeTarget.dataset.discountType === 'amount') this.handleAmountChanged();
    else this.handlePercentChanged();

    if (this.revenueCategoriesTypeTarget.dataset.appliesToAllRevenueCategories !== 'false') {
      this.handleAllRevenueCategories();
    } else {
      this.handleSelectedRevenueCategories();
    }

    $('#menu_discount_menu_id').select2();
  }

  handleAmountChanged() {
    this.amountWrapperTarget.classList.remove('hidden');
    this.percentWrapperTarget.classList.add('hidden');
    this.minDiscountWrapperTarget.classList.add('hidden');
    this.maxDiscountWrapperTarget.classList.add('hidden');
  }

  handlePercentChanged() {
    this.amountWrapperTarget.classList.add('hidden');
    this.percentWrapperTarget.classList.remove('hidden');
    this.minDiscountWrapperTarget.classList.remove('hidden');
    this.maxDiscountWrapperTarget.classList.remove('hidden');
  }

  handleAllRevenueCategories() {
    this.revenueCategoriesWrapperTarget.classList.add('hidden');
  }

  handleSelectedRevenueCategories() {
    this.revenueCategoriesWrapperTarget.classList.remove('hidden');
    if (this.revenueCategoryListTarget.innerHTML === '') this.populateRevenueCategories();
  }

  disableSelectCategory() {
    this.selectCategoriesTarget.disabled = true;
  }

  enableSelectCategory() {
    this.selectCategoriesTarget.disabled = false;
  }

  handleMenuChanged() {
    this.disableSelectCategory();
    this.populateRevenueCategories();
  }

  async populateRevenueCategories() {
    this.revenueCategoryListTarget.innerHTML = ''
    const categories = await this.fetchRevenueCategories();

    categories.forEach(category => {
      let checked = this.revenueCategoryListTarget.dataset.persistedRevenueCategories.includes(category.id) ? 'checked' : ''
      this.addRevenueCategoryOption(category.id, category.name, checked)
    });
    this.enableSelectCategory();
  }

  addRevenueCategoryOption(revCatId, title, checked) {
    let content = this.revenueCategoryOptionTemplate({ revCatId, title, checked })
    this.revenueCategoryListTarget.insertAdjacentHTML('beforeend', content)
  }

  async fetchRevenueCategories() {
    try {
      const menu_id = this.menuTarget.value
      const response = await fetch(`${this.API_BASE_URL}/revenue_categories.json?menu_id=${menu_id}`)
      return response.json();
    } catch (err) {
      console.error(err);
      const message = err?.message || err?.error || 'Something went wrong, please refresh the page and try again.'
      flashAlert(message);
      return [];
    }
  }
}
